import { useTranslations } from "next-intl"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    supplyPoint: graphql(`
        fragment useFormatSupplyPointMeterType_SupplyPoint on SupplyPointType {
            marketName
        }
    `),
}

export function useFormatSupplyPointMeterType() {
    const t = useTranslations("useFormatSupplyPointMeterType")

    return (supplyPoint: FragmentOf<typeof graphQLFragments.supplyPoint>) => {
        const { marketName } = readFragment(graphQLFragments.supplyPoint, supplyPoint)

        return t(`marketName`, { marketName })
    }
}

useFormatSupplyPointMeterType.messages = ["useFormatSupplyPointMeterType"] as const
useFormatSupplyPointMeterType.fragments = graphQLFragments
